module.exports = __webpack_public_path__ + "75e1a43019735790a4c4fb7787fafac7.jpg";